<div class="n-oldalfej">
  <div>
    <h2>Átalányadós elszámolás</h2>
    <span class="n-alcim">{{ aktiv.ugyfelNev || 'nincs kiválasztott ügyfél' }} · negyedévenként, havi bontásban</span>
  </div>
  <div class="spacer"></div>
  <label class="ev-valaszto" *ngIf="jogviszonyok.length">Egyéni vállalkozó
    <select [ngModel]="valasztott?.id" (ngModelChange)="valasztId($event)"><option *ngFor="let j of jogviszonyok" [ngValue]="j.id">{{ j.alkalmazott_nev }}</option></select>
  </label>
  <label class="ev-valaszto">Év
    <select [ngModel]="aktiv.ev" (ngModelChange)="evValt(+$event)"><option *ngFor="let e of evek" [ngValue]="e">{{ e }}</option></select>
  </label>
</div>

<div class="ures" *ngIf="!aktiv.ugyfelId"><ion-icon name="business-outline"></ion-icon>Válassz ügyfelet (Törzsadatok → Ügyfelek).</div>

<div class="ures" *ngIf="aktiv.ugyfelId && !aktiv.atalanyado">
  <ion-icon name="cash-outline"></ion-icon>
  {{ aktiv.ugyfelNev }} nem átalányadózó (adózási forma: {{ aktiv.adozas || '—' }}). Ha mégis az, az Ügyfelek törzsben,
  az ügyfél szerkesztésénél jelöld be az „Átalányadózó egyéni vállalkozó” mezőt.
</div>

<div class="ures" *ngIf="aktiv.ugyfelId && aktiv.atalanyado && !jogviszonyok.length">
  <ion-icon name="cash-outline"></ion-icon>
  Nincs átalányadós (egyéni vállalkozó) jogviszony. Az Alkalmazottaknál vegyél fel egy alkalmazottat
  <b>„Egyéni vállalkozó”</b> jogviszonnyal, és állítsd be a tevékenység szerinti költséghányadot.
</div>

<ng-container *ngIf="aktiv.ugyfelId && aktiv.atalanyado && jogviszonyok.length && valasztott">
  <div class="n-szuro-sor">
    <span class="cimke sarga">Költséghányad: {{ khanyadCimke }}</span>
    <span class="cimke">{{ rogzitettHonap }} / 12 hónap rögzítve</span>
    <span class="halvany ata-tipp">A költséghányad a jogviszonynál állítható (Alkalmazottak → jogviszony). Egy negyedévre vagy hónapra kattintva rögzíthetők a havi adatok.</span>
  </div>

  <!-- ÉVES ÖSSZESÍTŐ -->
  <div class="ata-kpi">
    <div class="n-panel ata-k"><span>Árbevétel ({{ aktiv.ev }})</span><b>{{ ossz('arbevetel') | number:'1.0-0' }} Ft</b>
      <div class="ata-sav" [title]="'A bevételi határ ' + (bevetelHatar | number:'1.0-0') + ' Ft (a minimálbér éves összegének tízszerese; kiskereskedőnél ötvenszerese)'">
        <i [style.width.%]="arany(ossz('arbevetel'), bevetelHatar)" [class.veszely]="arany(ossz('arbevetel'), bevetelHatar) > 90"></i></div>
      <small>a bevételi határ {{ arany(ossz('arbevetel'), bevetelHatar) }}%-a ({{ bevetelHatar | number:'1.0-0' }} Ft)</small></div>
    <div class="n-panel ata-k"><span>Jövedelem</span><b>{{ ossz('jovedelem') | number:'1.0-0' }} Ft</b>
      <small>árbevétel × (1 − {{ valasztott ? effKhanyad : '—' }}%)</small></div>
    <div class="n-panel ata-k"><span>Adómentes rész</span><b>{{ ossz('adomentes_resz') | number:'1.0-0' }} Ft</b>
      <div class="ata-sav"><i [style.width.%]="arany(ossz('adomentes_resz'), mentesKeret)"></i></div>
      <small>az éves keret {{ arany(ossz('adomentes_resz'), mentesKeret) }}%-a ({{ mentesKeret | number:'1.0-0' }} Ft)</small></div>
    <div class="n-panel ata-k ata-teher"><span>Becsült közterhek</span><b>{{ ossz('kozteher') | number:'1.0-0' }} Ft</b>
      <small>SZJA {{ ossz('szja') | number:'1.0-0' }} · TB {{ ossz('tb') | number:'1.0-0' }} · szocho {{ ossz('szocho') | number:'1.0-0' }}</small></div>
  </div>

  <!-- NEGYEDÉVEK -->
  <div class="ber-negyedek">
    <button type="button" class="n-panel ber-negyed" *ngFor="let q of negyedevek" (click)="uj(q.negyedev)" [class.ures-negyed]="!q.vanAdat">
      <div class="ata-nfej"><span class="n-panel-cim">{{ q.negyedev }}. negyedév</span>
        <span class="cimke" [class.zold]="q.rogzitettHo === 3" [class.sarga]="q.rogzitettHo > 0 && q.rogzitettHo < 3">{{ q.rogzitettHo === 3 ? 'rögzítve' : (q.rogzitettHo ? q.rogzitettHo + '/3 hónap' : 'nincs adat') }}</span></div>
      <ng-container *ngIf="q.vanAdat">
        <div class="ber-sor"><span>Árbevétel</span><b>{{ q.arbevetel | number:'1.0-0' }}</b></div>
        <div class="ber-sor"><span>Jövedelem</span><b>{{ q.jovedelem | number:'1.0-0' }}</b></div>
        <div class="ber-sor"><span>SZJA-alap</span><b>{{ q.szja_alap | number:'1.0-0' }}</b></div>
        <div class="ber-sor ata-osszes"><span>Becsült közteher</span><b>{{ q.kozteher | number:'1.0-0' }}</b></div>
      </ng-container>
      <div *ngIf="!q.vanAdat" class="halvany">Kattints a havi adatok felvételéhez.</div>
      <span class="ata-gomb">{{ q.vanAdat ? 'Módosítás' : 'Rögzítés' }} →</span>
    </button>
  </div>

  <!-- HAVI BONTÁS -->
  <div class="tabla-wrap">
    <table class="n-racs ata-racs">
      <thead><tr>
        <th>Hónap</th><th class="num">Árbevétel</th><th class="num">Jövedelem</th><th class="num">Adómentes</th>
        <th class="num" *ngIf="vanSzjaMentes" title="Anyák kedvezménye, NÉTAK, 25 / 30 év alattiak mentessége – a járulékot nem érinti">SZJA-mentes</th>
        <th class="num cs-afa">SZJA-alap</th><th class="num cs-afa">SZJA ({{ szazalekKulcsok.szja }}%)</th>
        <th class="num cs-penz">Tb-alap</th><th class="num cs-penz">TB ({{ szazalekKulcsok.tb }}%)</th>
        <th class="num cs-penz">Szocho-alap</th><th class="num cs-penz">Szocho ({{ szazalekKulcsok.szocho }}%)</th><th class="num">Közteher</th>
      </tr></thead>
      <tbody>
        <tr *ngFor="let h of honapok" [class.ata-ures]="!h.van" (click)="uj(h.negyedev)" title="A negyedév megnyitása">
          <td><b>{{ honapNev(h.ho) }}</b><span class="halvany" *ngIf="h.kieso_nap"> · {{ h.kieso_nap }} kieső nap</span></td>
          <td class="num">{{ h.van ? (h.arbevetel | number:'1.0-0') : '' }}</td>
          <td class="num">{{ h.van ? (h.jovedelem | number:'1.0-0') : '' }}</td>
          <td class="num">{{ h.van ? (h.adomentes_resz | number:'1.0-0') : '' }}</td>
          <td class="num" *ngIf="vanSzjaMentes" [title]="h.szja_mentes_cim || ''">{{ h.van ? (h.szja_mentes | number:'1.0-0') : '' }}</td>
          <td class="num cs-afa">{{ h.van ? (h.szja_alap | number:'1.0-0') : '' }}</td>
          <td class="num cs-afa">{{ h.van ? (h.szja | number:'1.0-0') : '' }}</td>
          <td class="num cs-penz">{{ h.van ? (h.tb_alap | number:'1.0-0') : '' }}</td>
          <td class="num cs-penz">{{ h.van ? (h.tb | number:'1.0-0') : '' }}</td>
          <td class="num cs-penz">{{ h.van ? (h.szocho_alap | number:'1.0-0') : '' }}</td>
          <td class="num cs-penz">{{ h.van ? (h.szocho | number:'1.0-0') : '' }}</td>
          <td class="num"><b>{{ h.van ? (h.kozteher | number:'1.0-0') : '' }}</b></td>
        </tr>
      </tbody>
      <tfoot><tr>
        <td>Összesen</td><td class="num">{{ ossz('arbevetel') | number:'1.0-0' }}</td><td class="num">{{ ossz('jovedelem') | number:'1.0-0' }}</td>
        <td class="num">{{ ossz('adomentes_resz') | number:'1.0-0' }}</td><td class="num" *ngIf="vanSzjaMentes">{{ ossz('szja_mentes') | number:'1.0-0' }}</td><td class="num cs-afa">{{ ossz('szja_alap') | number:'1.0-0' }}</td>
        <td class="num cs-afa">{{ ossz('szja') | number:'1.0-0' }}</td><td class="num cs-penz">{{ ossz('tb_alap') | number:'1.0-0' }}</td>
        <td class="num cs-penz">{{ ossz('tb') | number:'1.0-0' }}</td><td class="num cs-penz">{{ ossz('szocho_alap') | number:'1.0-0' }}</td>
        <td class="num cs-penz">{{ ossz('szocho') | number:'1.0-0' }}</td><td class="num"><b>{{ ossz('kozteher') | number:'1.0-0' }}</b></td>
      </tr></tfoot>
    </table>
  </div>

  <!-- HOGYAN SZÁMOL -->
  <div class="n-panel ata-info">
    <div class="n-panel-cim">Hogyan számol</div>
    <ul>
      <li><b>Jövedelem</b> = árbevétel × (1 − költséghányad). A költséghányad a jogviszonynál állítható.</li>
      <li><b>Adómentes rész</b>: a minimálbér éves összegének fele ({{ mentesKeret | number:'1.0-0' }} Ft) – hónapról hónapra göngyölítve fogy el.</li>
      <li><b>SZJA-alap</b>: a jövedelem adómentes kereten felüli része; az SZJA {{ szazalekKulcsok.szja }}%.</li>
      <li><b>Tb- és szocho-alap</b>: az SZJA-alap, de legalább a (garantált) minimálbér havonta, a kieső napokkal arányosan csökkentve;
        TB {{ szazalekKulcsok.tb }}%, szocho {{ szazalekKulcsok.szocho }}%.</li>
      <li>A kulcsok és a minimálbér a <b>Törzsadatok → Évi paraméterek</b> képernyőről jönnek. A közterhek becsültek – a bevallás a mérvadó.</li>
    </ul>
  </div>
</ng-container>

<!-- Havi bontású negyedéves számfejtő -->
<ion-modal #szerkModal cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej">
      <ion-title>Átalányadózó EV – {{ szerk?.negyedev }}. negyedév</ion-title>
      <ion-buttons slot="end"><ion-button (click)="szerkModal.dismiss()">Bezár</ion-button></ion-buttons>
    </ion-toolbar></ion-header>
    <div class="nk-torzs">
      <div class="nk-form" *ngIf="szerk">
        <p style="margin:0"><b>{{ valasztott?.alkalmazott_nev }}</b> · költséghányad: {{ szerk.khanyad }}%</p>
        <div class="n-panel ho-panel" *ngFor="let h of szerk.honapok">
          <div class="n-panel-cim">{{ honapNev(h.ho) }}</div>
          <div class="ho-mezok">
            <label class="kv-mezo"><span>Havi árbevétel</span>
              <span class="kv-egyutt"><input type="number" [(ngModel)]="h.arbevetel" (ngModelChange)="szamol()">
                <button type="button" class="kv-mini" *ngIf="naploKotott" (click)="naplobolHo(h)" [disabled]="naplobolFut" title="A NAPLO-ból"><ion-icon name="download-outline"></ion-icon></button></span></label>
            <label class="kv-mezo"><span>Kieső nap</span><input type="number" [(ngModel)]="h.kieso_nap" (ngModelChange)="szamol()"></label>
            <span class="halvany">Összes nap: <b>{{ h.osszes_nap }}</b></span>
          </div>
          <div class="ho-szamitott">
            <span>Havi jövedelem: <b>{{ h.jovedelem | number:'1.0-0' }}</b></span>
            <span>Adómentes rész: <b>{{ h.adomentes_resz | number:'1.0-0' }}</b></span>
            <span *ngIf="h.szja_mentes" [title]="'A járulékalapot nem csökkenti'">{{ h.szja_mentes_cim || 'SZJA-mentes' }}: <b>{{ h.szja_mentes | number:'1.0-0' }}</b></span>
            <span>SZJA-alap: <b>{{ h.szja_alap | number:'1.0-0' }}</b></span>
            <span>Tb.jár.alap: <b>{{ h.tb_alap | number:'1.0-0' }}</b></span>
            <span>Szoc.adó alap: <b>{{ h.szocho_alap | number:'1.0-0' }}</b></span>
            <span class="min">Min.jár.alap: {{ h.min_jar_alap | number:'1.0-0' }}</span>
          </div>
        </div>
        <div class="tabla-wrap" style="margin:0">
          <table class="n-racs">
            <thead><tr><th></th><th class="num">Árbevétel</th><th class="num">Jövedelem</th><th class="num">Adómentes</th><th class="num">SZJA-alap</th><th class="num">Tb.jár.alap</th><th class="num">Szoc.adó alap</th></tr></thead>
            <tbody>
              <tr><td>Előző időszakok göngy.</td>
                <td class="num">{{ szerk.elozo.arbevetel | number:'1.0-0' }}</td><td class="num">{{ szerk.elozo.jovedelem | number:'1.0-0' }}</td>
                <td class="num">{{ szerk.elozo.adomentes_resz | number:'1.0-0' }}</td><td class="num">{{ szerk.elozo.szja_alap | number:'1.0-0' }}</td>
                <td class="num">{{ szerk.elozo.tb_alap | number:'1.0-0' }}</td><td class="num">{{ szerk.elozo.szocho_alap | number:'1.0-0' }}</td></tr>
              <tr><td>Aktuális negyedév össz.</td>
                <td class="num">{{ szerk.negyedevOssz.arbevetel | number:'1.0-0' }}</td><td class="num">{{ szerk.negyedevOssz.jovedelem | number:'1.0-0' }}</td>
                <td class="num">{{ szerk.negyedevOssz.adomentes_resz | number:'1.0-0' }}</td><td class="num">{{ szerk.negyedevOssz.szja_alap | number:'1.0-0' }}</td>
                <td class="num">{{ szerk.negyedevOssz.tb_alap | number:'1.0-0' }}</td><td class="num">{{ szerk.negyedevOssz.szocho_alap | number:'1.0-0' }}</td></tr>
            </tbody>
            <tfoot><tr><td>Jogviszony mindösszesen</td>
              <td class="num">{{ szerk.mindossz.arbevetel | number:'1.0-0' }}</td><td class="num">{{ szerk.mindossz.jovedelem | number:'1.0-0' }}</td>
              <td class="num">{{ szerk.mindossz.adomentes_resz | number:'1.0-0' }}</td><td class="num">{{ szerk.mindossz.szja_alap | number:'1.0-0' }}</td>
              <td class="num">{{ szerk.mindossz.tb_alap | number:'1.0-0' }}</td><td class="num">{{ szerk.mindossz.szocho_alap | number:'1.0-0' }}</td></tr></tfoot>
          </table>
        </div>
        <div class="nk-lab">
          <button type="button" class="ov-gomb" [disabled]="bevallasFut" (click)="bevallasNyit()"
                  title="A negyedév 2658-as bevallásának megnyitása a nyomtatványkitöltőben">
            <ion-icon name="document-text-outline"></ion-icon>{{ bevallasFut ? 'Előkészítés…' : 'Bevallás (2658)' }}</button>
          <button type="button" class="ov-gomb fo" (click)="mentes()"><ion-icon name="save-outline"></ion-icon>Negyedév mentése</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>
